<template>
    <loading-page :permanent="true" override-message="Sign-in in Progress" />
</template>

<script>
import mgr from '@/store/user-manager';
import LoadingPage from '@/components/shared/loading/loading-page';

export default {
    name: 'signin',

    components: {
        LoadingPage,
    },
    async mounted() {
        await mgr.signoutRedirect();
        await mgr.signinRedirect();
    },
};
</script>
